import React from 'react';
import PropTypes from 'prop-types';
import { ListItemButton, ListItemIcon, ListItemText } from '@mui/material';
import AddCircleOutlineRoundedIcon from '@mui/icons-material/AddCircleOutlineRounded';

const LandingPageDynEl = function LandingPageDynEl({
  id = '',
  name = '',
  onClick = () => {},
}) {
  return (
    <ListItemButton
      key={id}
      id={id}
      onClick={() => onClick(`{LPG.${id}}`)}
      sx={{
        cursor: 'pointer',
      }}
      divider
    >
      <ListItemIcon>
        <AddCircleOutlineRoundedIcon />
      </ListItemIcon>
      <ListItemText primary={name} />
    </ListItemButton>
  );
};

LandingPageDynEl.propTypes = {
  id: PropTypes.string,
  name: PropTypes.string,
  onClick: PropTypes.func,
};
export default LandingPageDynEl;
